<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false" :modal="false">
        <div class="carBox">
            <el-card class="box-card" style="width: 280px;margin-right: 20px">
                <el-tree :data="orgData" @node-click="clickOrg" default-expand-all :expand-on-click-node="false"></el-tree>
            </el-card>
            <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
                <div class="mainBody">
                    <div class="searchBox">
                        <div class="searchGroup">
                            <label>用户名：</label>
                            <el-input v-model="search_Obj.f_username" clearable @keyup.enter.native="doSearch"></el-input>
                        </div>
                        <div class="searchGroup">
                            <label>姓名：</label>
                            <el-input v-model="search_Obj.f_realname" clearable @keyup.enter.native="doSearch"></el-input>
                        </div>
                        <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                        <el-button type="primary"  @click="selUsers">添加选中</el-button>
                    </div>
                    <div class="dataBox">
                        <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                            <el-table-column type="selection" align="center" width="50"></el-table-column>
                            <el-table-column prop="username" label="用户名" sortable="custom" width="150"></el-table-column>
                            <el-table-column prop="realname" label="姓名" sortable="custom" width="150"></el-table-column>
                            <el-table-column prop="org_name" label="所在机构" sortable="custom"></el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button size="mini" plain type="primary" @click="selThis(scope.row)">选择</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";
import { getOrgTreeData } from '@/api/org'

export default {
    name: 'userListDevice',
    mixins: [listutil],
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        device_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        device_type: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.device_id = this.device_id;
            this.search_Obj.device_type = this.device_type;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '用户',
            menu_id: 1100,
            list_url: "/api/admin/user/deviceUserList",
            enu_name: [],
            search_Obj: {
                f_username: '',
                f_realname: '',
                f_state: '',
                org_id: '',
                device_id: '',
                device_type: ''
            },
            orgData: [],
            showflag: false,
        };
    },
    methods: {
        loadOtherData() {
            this.orgData = []
            getOrgTreeData().then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.orgData = treeData
                }
            })
        },
        clickOrg(data){
            this.search_Obj.org_id = data.id
            this.getListData()
        },
        closeDialog() {
            this.$emit("on-close")
        },
        selThis(obj){
            this.$emit("setUser", obj.id)
        },
        selUsers(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要添加的用户")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                this.$emit("setUser", ids)
            }
        }
    }
};
</script>